import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Frown, Receipt } from 'lucide-react';
export function PainPoint() {
  return <section className="py-20 px-6 bg-sage" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl relative" data-id="element-63">
          {/* Decorative quote mark */}
          <div className="absolute -top-6 -left-6 text-terracotta opacity-20 text-9xl font-serif leading-none" data-id="element-64">
            "
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-forest font-bold mb-8 text-center" data-id="element-65">
            Llegás a las 7 de la tarde después de un día eterno...
          </h2>

          <div className="space-y-6 text-lg text-brown font-sans leading-relaxed" data-id="element-66">
            <p data-id="element-67">
              Lo primero que escuchás es:{' '}
              <span className="font-bold italic" data-id="element-68">"¿Qué hay de comer?"</span>.
              Abrís la heladera y solo hay un limón seco y un pote de queso
              crema vencido.
            </p>
            <p data-id="element-69">
              Tu cuerpo te pide algo sano, pero tu cabeza no tiene espacio para
              pensar una receta. El resultado es siempre el mismo:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-10" data-id="element-70">
            <div className="bg-cream p-6 rounded-xl text-center flex flex-col items-center" data-id="element-71">
              <Clock className="w-10 h-10 text-terracotta mb-4" data-id="element-72" />
              <p className="font-bold text-forest" data-id="element-73">El delivery de siempre</p>
              <p className="text-sm text-brown mt-2" data-id="element-74">
                Comida pesada que te cae mal
              </p>
            </div>
            <div className="bg-cream p-6 rounded-xl text-center flex flex-col items-center" data-id="element-75">
              <Receipt className="w-10 h-10 text-terracotta mb-4" data-id="element-76" />
              <p className="font-bold text-forest" data-id="element-77">15 lucas menos</p>
              <p className="text-sm text-brown mt-2" data-id="element-78">
                En la cuenta bancaria, otra vez
              </p>
            </div>
            <div className="bg-cream p-6 rounded-xl text-center flex flex-col items-center" data-id="element-79">
              <Frown className="w-10 h-10 text-terracotta mb-4" data-id="element-80" />
              <p className="font-bold text-forest" data-id="element-81">Esa culpa</p>
              <p className="text-sm text-brown mt-2" data-id="element-82">
                Que no te deja dormir tranquila
              </p>
            </div>
          </div>

          <div className="mt-12 text-center border-t border-sage pt-8" data-id="element-83">
            <h3 className="text-2xl font-serif text-terracotta font-bold italic" data-id="element-84">
              Sé exactamente cómo te sentís.
            </h3>
            <p className="mt-4 text-brown max-w-2xl mx-auto" data-id="element-85">
              Sentís que para comer sano tenés que vivir en la cocina o gastar
              una fortuna en una dietética. Intentaste organizar las compras,
              pero el brócoli se te puso amarillo en el cajón y terminaste
              tirando plata a la basura.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}